import { User } from 'app/core/user/user.types';
import { Feature } from 'geojson';
import { MinimumDocument, ServiceRequestTypePopulate } from './serviceType';

/**
 * Solicitação de servico
 */

//O ServiceRequest que vem do banco de dados
export class ServiceRequest {
    _id: string;
    user_request: User | string;
    user_rt: User[];
    description: string;
    type: string;
    statusHistory: {
        status: StatusService;
        date: Date;
        user: string; // Usuário que realizou a mudança
    }[];
    status: StatusService;
    layers: string[];
    rasters: string[];
    geometry?: Feature;
    deadlines?: Deadlines[];
    lastNotificationDocument: Date;
    currentCities: string[];
    createdAt: string;
    updatedAt: string;
    __v: number;
}

//Classe para criar o createServiceResquest
export class CreateServiceRequest {
    user_request: string;
    user_rt: string[];
    layers: string[];
    rasters: string[];
    description: string;
    serviceType: string;
    geometry: Feature;
    deadlines?: Deadlines[];
}

export class Deadlines {
    name: string;
    description: string;
    email: string;
    notificationDate: Date;
}

//Paginação de Service Request
export class ServiceRequestPaginate {
    services: ServiceRequest[];
    total: number;
}

//Service Requeste mas com populate de type.
export class ServiceRequestPopulate {
    _id: string;
    user_request: string;
    user_rt: string[];
    description: string;
    serviceType: ServiceRequestTypePopulate;
    minimumdocuments: MinimumDocument[];
    layers: string[];
    rasters: string[];
    deadlines?: Deadlines[];
    lastNotificationDocument: Date;
    status: StatusService;
    statusHistory: {
        status: StatusService;
        date: Date;
        user: string; // Usuário que realizou a mudança
    }[];
    geometry: Feature;
    createdAt: string;
    updatedAt: string;
    __v: number;
}

export enum EnumServiceArea {
    ENGENHARIA = 'ENGENHARIA',
    ARQUITETURA = 'ARQUITETURA',
    TOPOGRAFIA = 'TOPOGRAFIA',
    GEOTECNICO = 'GEOTECNICO',
    MEIOAMBIENTE = 'MEIOAMBIENTE',
    GESTAOIMOBILIARIA = 'GESTAOIMOBILIARIA',
}

export enum EnumTranslateServiceArea {
    ENGENHARIA = 'Engenharia',
    ARQUITETURA = 'Arquitetura',
    TOPOGRAFIA = 'Topografia',
    GEOTECNICO = 'Geotecnico',
    MEIOAMBIENTE = 'Meio Ambiente',
    GESTAOIMOBILIARIA = 'Gestão Imobiliária',
}

export enum StatusService {
    PENDING = 'PENDING', // Serviço aguardando ação ou decisão
    IN_PROGRESS = 'IN_PROGRESS', // Serviço em andamento
    FILED = 'FILED', // Serviço protocolado
    CLOSE = 'CLOSE', // Serviço encerrado ou finalizado
}

export enum EnumTranslateStatusService {
    PENDING = 'Pendente', // Serviço aguardando ação ou decisão
    IN_PROGRESS = 'Em andamento', // Serviço em andamento
    FILED = 'Protocolado', // Serviço protocolado
    CLOSE = 'Fechado', // Serviço encerrado ou finalizado
}

export enum StatusColors {
    PENDING = '#FFCC00', // Amarelo
    IN_PROGRESS = '#007BFF', // Azul
    FILED = '#28A745', // Verde
    CLOSE = '#6C757D', // Cinza
}
